import { MouseEvent } from 'react'
import ToggleButtonGroup from '~/src/components/mui-wrappers/styled/ToggleButtonGroup'
import ToggleButton from '~/src/components/mui-wrappers/styled/ToggleButton'
import { useDeliveryMethodsDate } from '~/src/hooks/delivery-methods/useDeliveryMethodsDate'
import { useTranslations } from '~/src/hooks/useTranslations'
import { useFirmAcceptsOrder } from '~/src/hooks/orders/useFirmAcceptsOrder'

interface Props {
  onChange(event: MouseEvent, value: string): void,
  value: string,
}

const DeliveryMethodsDateButtonGroup = ({ onChange, value }: Props) => {
  const { t } = useTranslations()
  const { canToday, canTomorrow, canPick } = useDeliveryMethodsDate()
  const { checkOrderIsLimitedToSameDay } = useFirmAcceptsOrder()

  return (
    <ToggleButtonGroup
      color="primary"
      exclusive
      onChange={onChange}
      value={value}
    >
      <ToggleButton value='today' disabled={!canToday}>{t('global.today')}</ToggleButton>
      { !checkOrderIsLimitedToSameDay() && <ToggleButton value='tomorrow' disabled={!canTomorrow}>{t('global.tomorrow')}</ToggleButton> }
      { !checkOrderIsLimitedToSameDay() && <ToggleButton value='pick' disabled={!canPick}>{t('global.pick_a_date')}</ToggleButton> }
    </ToggleButtonGroup>
  )
}

export default DeliveryMethodsDateButtonGroup
